import { Reveal, Eyebrow, WhatsAppIcon, InstagramIcon } from "./Reveal";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL, SCENES, WA_MSG, wa, WHATSAPP_DISPLAY } from "../constants/site";

const STEPS = [
    { n: "1", title: "Chame no WhatsApp", desc: "Clique no botão e fale com a gente." },
    { n: "2", title: "Receba seu acesso", desc: "Teste grátis ou plano escolhido, em minutos." },
    { n: "3", title: "Assista tudo", desc: "Instalação guiada na sua tela favorita." },
];

export const Contact = () => (
    <section id="contato" className="px-5 pb-20 md:px-8 md:pb-28" data-testid="contact-section">
        <Reveal className="mx-auto max-w-7xl">
            <div className="relative overflow-hidden rounded-[2.5rem] border border-[#222232] px-6 py-14 text-center md:px-16 md:py-20">
                <img
                    src={SCENES.theater}
                    alt=""
                    aria-hidden
                    loading="lazy"
                    className="absolute inset-0 h-full w-full object-cover opacity-30"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-[#070709]/80 via-[#070709]/70 to-[#070709]/90" />
                <div
                    aria-hidden
                    className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-[#E50914]/25 blur-3xl"
                />

                <div className="relative">
                    <Eyebrow>Fale com a gente</Eyebrow>
                    <h2 className="mx-auto mt-5 max-w-2xl text-3xl font-bold text-white sm:text-4xl lg:text-5xl">
                        Pronto para dar o play hoje mesmo?
                    </h2>
                    <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-white/70 md:text-lg">
                        Chame no WhatsApp, peça seu teste grátis e veja a
                        qualidade com seus próprios olhos antes de assinar.
                    </p>

                    <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
                        <a
                            href={wa(WA_MSG.trial)}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="contact-whatsapp-btn"
                            className="inline-flex items-center gap-2.5 rounded-full bg-[#25D366] px-8 py-4 text-base font-bold text-white shadow-xl shadow-[#25D366]/25 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#1fb857]"
                        >
                            <WhatsAppIcon className="h-5 w-5" />
                            WhatsApp {WHATSAPP_DISPLAY}
                        </a>
                        <a
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="contact-instagram-btn"
                            className="inline-flex items-center gap-2.5 rounded-full border-2 border-white/25 px-8 py-4 text-base font-bold text-white transition-all duration-300 hover:border-white/60 hover:bg-white/10"
                        >
                            <InstagramIcon className="h-5 w-5" />
                            {INSTAGRAM_HANDLE}
                        </a>
                    </div>

                    <div className="mt-14 grid grid-cols-1 gap-4 text-left sm:grid-cols-3">
                        {STEPS.map((s) => (
                            <div
                                key={s.n}
                                className="rounded-2xl border border-white/10 bg-[#0E0E14]/70 p-6 backdrop-blur"
                            >
                                <span className="grid h-9 w-9 place-items-center rounded-full bg-[#E50914] font-display text-sm font-extrabold text-white">
                                    {s.n}
                                </span>
                                <h3 className="mt-4 font-display text-base font-bold text-white md:text-lg">
                                    {s.title}
                                </h3>
                                <p className="mt-1 text-sm leading-relaxed text-white/60">
                                    {s.desc}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Reveal>
    </section>
);
